import { FastField } from 'formik';
import { SttNumberInput } from '@stt-componentes/core';
import { NUMERO_EXAME } from '../fieldNames';

const NumeroExame = ({ strings }) => {  
      
    return (
        <FastField name={NUMERO_EXAME}>
            {({
                field
            }) => (
                <SttNumberInput
                    label={strings.numeroLaudo}
                    inputProps={{
                        inputMode: 'numeric'
                    }}
                    {...field}
                />
            )}
        </FastField>
    );
};

export default NumeroExame;